import React from 'react'
import { getLrc20SendTx } from '../../util/new-api';
import { getBtcUtxos } from '../../util/ordinal';
import { postUnisatTransaction } from '../../util/api';
import { prepareSrc20Wallet } from '../../util/stamp-api';
import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, loopTilAddressReceivesMoney, waitSomeSeconds, addressReceivedMoneyInThisTx, pushBTCpmt, calculateFeeReal, getData, isValidTaprootAddress} from '../../util/inscribe-util';
import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding } from '../../configs/constant';
import SolanaConnect from '../../components/SolanaConnect';
import { useSelector } from 'react-redux';
import { payWithSolflareWallet, payWithMagicEdenWallet } from '../../util/solana-api';
import { bitcoinsdk } from "bitcoinsdk/core";
import { saveBrc20ClaimData, getBrc20ClaimData, getAllBrc20ClaimData, updateBrc20ClaimData } from '../../util/brc20-api';
import { registerReferalCode, registerReferalHistory, getReferalHistory } from '../../util/refer-api';
import DoubleProgressBar from '../../components/ProgressBar/DoubleProgressBar';
import { saveOp20TradeData, splitPsbt } from '../../util/op20-api';

export default function Test() {
  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const solanaWallet = useSelector(state => state.solanaWallet);

  const handleClick = async () => {

    let pubkey = await window.unisat.getPublicKey();
    console.log("pubkey", pubkey);

    // let res = await window.unisat.signMessage("user", "bip322-simple");
    // console.log("res", res)

    // const listData = [
    //   {
    //     actualPrice: 2000,
    //     txid: "fdbf3357d66bff998078458622d4b4729daa19fed3f939ab85c01696c71abff1:1",
    //     vout: 1,
    //     value: 333,
    //     amount: 200,
    //     unitPrice: 10,
    //     totalPrice: 3000,
    //     address: "bc1px92c229fgrewwz2lp9s05v47rkjw4zvdm87mwc806jxpz9cckstqn7sqlm"

    //   },
    //   {
    //     actualPrice: 2000,
    //     txid: "1999947263ddaf5099a3e2020baf076874e9336b7810ad5f0195b91fbd92ebfd:1",
    //     vout: 1,
    //     value: 333,
    //     amount: 200,
    //     unitPrice: 10,
    //     totalPrice: 3000,
    //     address: "bc1px92c229fgrewwz2lp9s05v47rkjw4zvdm87mwc806jxpz9cckstqn7sqlm"
    //   }
    // ]

    
    const psbt = "70736274ff0100d10200000001fb02f2818d0d08d84d8356d50e4972656b07d109f18ec77cbe4db8d5e09e4efb0300000000fdffffff044a01000000000000225120b9904b3269453e6b8e06604019eb4b6df0e46a2829fa1560320122a7cc2d690d204e00000000000022512021e2aa6dc08f5bcf9c70c867c76ddd844186dd54dd1154eacbf7de7cf6f877eb0000000000000000146a5d11ff7f818cec82d08bc0a882e5eee489bc02de31010000000000225120569efa2c50b797dd545ceb685fa8aeb055cf4c28e8e103ea9dcd132a27487d66000000000001012b7e82010000000000225120569efa2c50b797dd545ceb685fa8aeb055cf4c28e8e103ea9dcd132a27487d66010304010000000117206c30776a694f4ea86cfca2e17f037ec817d48d1154f3e25aec6816dda0fb2eec0000000000";

    const signedPsbt = await window.unisat.signPsbt(psbt);
    await window.unisat.pushPsbt(signedPsbt);
    //  console.log("signedPsbt", signedPsbt);

    // const signedPsbtData = await splitPsbt({hex: signedPsbt})
    // const unsignedPsbtData = await splitPsbt({hex: psbt})

    // let updatedData = [];
    // for(let i = 0; i < listData.length; i++) {
    //   updatedData.push({
    //     ticker: "utxo",
    //     amount: listData[i].amount,
    //     unitPrice: listData[i].unitPrice,
    //     totalPrice: listData[i].totalPrice,
    //     ownerAddress: listData[i].address,
    //     utxoTxId: listData[i].txid,
    //     utxoVout: listData[i].vout,
    //     utxoValue: listData[i].value,
    //     psbt: unsignedPsbtData.hexArray[i],
    //     signedPsbt: signedPsbtData.hexArray[i],
    //     txId: "xxxx",
    //     receiverAddress: "bc1p3ns3qgpmyv4j4q00kauvf0xnpg42kf9rc5259n5g3247vhr7yqeqcca3fv",
    //     id: i + 3
    //   })
    // }

    // const updatedData = [
    //   {
    //     "txId": "11",
    //     "receiverAddress" : "receiverAddress",
    //     "id": 13,
    //     "totalPrice": 10000,
    //     "amount": 40,
    //     "ticker": "utxo"
    // }
    // ];
    // console.log("updatedData", updatedData);
    // await saveOp20TradeData({type: "buy", datas: updatedData});
    
  }
  const handlePay = async () => {
    await payWithMagicEdenWallet(solanaWallet.wallet, solanaWallet.publicKey, 'FBUQNtu6RWV6SuiQwgwXji1bxDvWGzkr6b7uQ4nfrGFC', 0.001, 'Install MagicEden Wallet Error Message');
  }

  const handleBrc20ApiTest = async () => {
    /*
    const data = await saveBrc20ClaimData({
      address: 'bc1p26005tzsk7ta64zuad59l29wkp2u7npgarss865ae5fj5f6g04nq5jxkpz',
      randomKey: '1234567890',
      ticker: 'TEST',
      inscribeAmount: 100000000,
      feerate: 2.5,
      receiveAddress: 'receiveAddress',
      inscriptionAddress: 'inscriptionAddress',
      fundingAddress: 'fundingAddress',
      fundingAmount: 100000,
      mode: 0
    });
    */

    let data = await updateBrc20ClaimData({
      randomKey: '1234567890',
      mode: 2,
      inscriptionId: 'cccccccc'
    })

    data = await getAllBrc20ClaimData({
      receiveAddress: 'receiveAddress',
      ticker: 'TEST',
      offset: 0,
      limit: 10
    });
    console.log("--------------", data);
  }

  return (
    <div className = "mt-[80px] text-white flex flex-col gap-4">
      <DoubleProgressBar
         confirmedPercent={25}
          pendingPercent={25}
      />
      <button onClick={handleClick}>Connect Wallet</button>
      <button onClick={handleBrc20ApiTest}>Brc20 Api Test</button>
      <SolanaConnect />
      <button onClick={handlePay}>Pay</button>
    </div>
  )
}
